// src/utils/api.js
const flaskUrl = "https://dev-api.predactica.com/api/v2";

// Helper function to get the token (adjust based on your token storage method)
const getToken = () => {
  const jsondata = localStorage.getItem('jsondata');
  if (jsondata) {
    const data = JSON.parse(jsondata);
    return data.accessToken;
  }
  else throw new Error('No token found');
};

// Helper function to create headers with the token
const getAuthHeaders = () => {
  const token = getToken();
  return {
    'Content-Type': 'application/json',
    'Authorization': token ? `Bearer ${token}` : '', // Add Bearer token if available
  };
};

export const startChat = async () => {
  const response = await fetch(`${flaskUrl}/chat/start/`, {
    method: 'POST',
    headers: getAuthHeaders(),
  });
  return await response.json();
};

export const getChatHistory = async (chatId) => {
  const response = await fetch(`${flaskUrl}/chat/history/${chatId}/`, {
    headers: getAuthHeaders(),
  });
  return await response.json();
};

export const getAllSessions = async () => {
  const response = await fetch(`${flaskUrl}/chat/sessions/`, {
    headers: getAuthHeaders(),
  });
  return await response.json();
};

export const deleteChatSession = async (chatId) => {
  const response = await fetch(`${flaskUrl}/chat/delete/${chatId}/`, {
    method: 'POST',
    headers: getAuthHeaders(),
  });
  return await response.json();
};

export const sendMessage = async (message, chatId) => {
  const response = await fetch(`${flaskUrl}/chat/message/`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({ message, chat_record_id: chatId }),
  });
  return await response.json();
};